const getCookie = (name) => {
  let a = `; ${document.cookie}`.match(`;\\s*${name}=([^;]+)`);
  return a ? a[1] : "";
};

export default getCookie;
